
        var result = require("!!../../../../node_modules/css-loader/index.js!./notifications-viewer.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/controls/notifications-viewer.component.css
// module id = 655
// module chunks = 0